<template>
  <DragDialog
    :title="getTitle()"
    :width="600"
    :visible.sync="visible"
    :footerBtn="['cancel', 'submit']"
    :submit="submit"
    :cancel="cancel">
    <div class="common-form-box">
      <el-form
        class="public-form-primary"
        :model="sceneForm"
        :rules="rules"
        label-width="96px"
        ref="sceneForm">
        <el-form-item
          label="场景名称："
          prop="sceneName">
          <div class="common-input-box">
            <el-input
              class="input-primary"
              size="small"
              :minlength="1"
              :maxlength="100"
              show-word-limit
              v-model="sceneForm.sceneName" />
          </div>
        </el-form-item>
        <el-form-item
          label="显示方式："
          prop="displayMode">
          <el-radio-group
            class="radio-group-box radio-primary"
            :disabled="sceneInfo.hasDataSets"
            v-model="sceneForm.displayMode"
            @input="handleShowModeChange">
            <el-radio label="Sphere">三维球体</el-radio>
            <el-radio label="Plane">平面</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item>
          <div class="crs-form-box">
            <div class="label">场景坐标系：</div>
            <div
              class="form-content"
              v-if="sceneForm.displayMode === 'Sphere'">
              {{ sceneForm.coordinates }}
            </div>
            <CrsForm
              v-else
              ref="crsForm"
              :dataType="sceneForm.displayMode"
              :disabled="sceneInfo.hasDataSets"
              :crsInfo="crsInfo" />
          </div>
        </el-form-item>
        <div class="thumbnail-uploader-box">
          <div class="label dialog-label">缩略图：</div>
          <el-upload
            class="upload-primary"
            ref="upload"
            drag
            :action="uploadUrl"
            :headers="headers"
            :data="uploadParams"
            name="FileInfo"
            accept=".jpg,.jpeg,.png"
            :show-file-list="false"
            :before-upload="handleBeforeUpload"
            :on-success="handleAvatarSuccess"
            :on-error="handleAvatarError">
            <div
              v-if="sceneForm.thumbnail"
              class="avatar-box">
              <img
                :src="`${imageBaseUrl}/${
                  sceneForm.thumbnail
                }?token=${getTokenId()}`"
                @error="defaultImg"
                :class="sceneForm.thumbnail ? 'avatar not-avatar' : 'avatar'" />
              <i
                class="el-icon-delete icon"
                @click="deleteImage"
                title="删除缩略图" />
            </div>
            <div
              v-else
              class="upload-tip">
              <!-- <icon-svg
                size="32"
                icon-class="ic-ico_upload"
                class="icon" /> -->
              <div class="tip-text">
                <i class="el-icon-plus avatar-uploader-icon"></i>
                <!-- <em class="text-btn">点击上传</em>/<span class="text-drap public-tips-primary">将文件拖到此处</span> -->
              </div>
            </div>
          </el-upload>
        </div>
      </el-form>
      <div
        class="tips-box"
        v-if="editMode === 'create'">
        <div class="icon-box">
          <span class="text public-tips-primary">注：</span>
        </div>
        <div class="tips-content-box">
          <div class="public-tips-primary">
            (1)仅允许空场景修改显示方式和坐标系
          </div>
          <div class="public-tips-primary">
            (2)指定场景坐标系后，会以此坐标系筛选遥感数据和wmts数据
          </div>
          <div class="public-tips-primary">
            (3)本平台仅支持使用Web墨卡托投影坐标系和分带投影坐标系。
          </div>
        </div>
      </div>
    </div>
  </DragDialog>
</template>

<script>
import DragDialog from '@/components/CustomDragDialog.vue'
import CrsForm from '@/components/CrsForm.vue'

import {
  getBase64,
  compressImgBySize,
  getToken,
  getTokenId
} from '@/utils/generalMethods'

import { createSceneService, modifySceneService } from '@/service/interface'

const CompressSize = 2 * 1024 * 1024

export default {
  data() {
    const validSceneNameRule = (rule, value, callback) => {
      if (value.length !== value.trimStart().trimEnd().length) {
        callback(new Error('开头和结尾不允许有空格'))
        return
      }

      if (value.length < 1 || value.length > 100) {
        callback(new Error('场景名称限制1-100个字符'))
        return
      }

      if (value.includes('\\') || value.includes('/')) {
        callback(new Error('场景名称不能包含正反斜杠'))
        return
      }

      callback()
    }

    return {
      editMode: 'create',
      sceneForm: {
        sceneName: '',
        displayMode: 'Sphere',
        coordinatesType: 'EPSG',
        coordinates: 'EPSG:3857',
        thumbnail: ''
      },
      imageBaseUrl: `${window.imageBaseUrl}`,
      uploadUrl: this.getUploadUrl(),
      headers: {
        Authorization: this.getToken()
      },
      uploadParams: {
        FileSize: '',
        FileName: ''
      },

      crsInfo: {
        crsType: 'EPSG',
        crsString: ''
      },

      rules: {
        sceneName: [
          {
            required: true,
            message: '请输入场景名称',
            trigger: 'blur'
          },
          { validator: validSceneNameRule }
        ],
        displayMode: [
          {
            required: true,
            message: '请选择场景显示方式',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  props: {
    visible: Boolean,
    sceneInfo: Object,
    updateDataList: Function,
    closeDialog: Function
  },
  components: {
    DragDialog,
    CrsForm
  },
  watch: {
    visible: function (newVal) {
      if (newVal) {
        let sceneInfo = this.sceneInfo
        if (Object.keys(sceneInfo).length) {
          this.editMode = 'edit'
          this.initSceneForm(sceneInfo)
        } else {
          this.editMode = 'create'
        }
      }
    }
  },
  methods: {
    defaultImg(img) {
      img.target.src = require('@/assets/img/scenePage.png')
    },
    initSceneForm(sceneInfo) {
      let sceneForm = {
        sceneId: sceneInfo.sceneId,
        sceneName: sceneInfo.sceneName,
        displayMode: sceneInfo.displayMode,
        coordinatesType: sceneInfo.coordinatesType,
        coordinates: sceneInfo.coordinates,
        thumbnail: sceneInfo.thumbnail
      }
      this.crsInfo = {
        crsType: sceneForm.coordinatesType,
        crsString: sceneForm.coordinates
      }
      this.sceneForm = sceneForm
    },
    handleShowModeChange(value) {
      if (value === 'Plane') {
        this.crsInfo = {
          crsType: 'EPSG',
          crsString: ''
        }
      } else {
        this.sceneForm.coordinatesType = 'EPSG'
        this.sceneForm.coordinates = 'EPSG:3857'
      }
    },
    submit() {
      let startInterval = setInterval(() => {
        this.disabled = false
        clearInterval(startInterval)
      }, 60000)

      if (!this.disabled) {
        this.$refs.sceneForm.validate((bool, object) => {
          if (bool) {
            this.disabled = true

            let sceneForm = this.sceneForm
            if (sceneForm.displayMode === 'Plane') {
              let crsParams = this.$refs.crsForm.getCrsParams()
              if (!crsParams) {
                this.disabled = false
                return
              }

              sceneForm.coordinatesType = crsParams.coordinatesType
              sceneForm.coordinates = crsParams.coordinates
            }

            if (this.editMode === 'create') {
              let projId = this.$route.params.projId
              sceneForm.projId = projId
              createSceneService(sceneForm).then(response => {
                if (response.isSuccess) {
                  this.updateDataList()

                  this.$message.success('创建成功')
                  this.cancel()
                  this.disabled = false
                } else {
                  this.$message.error(response.errMsg)
                  this.disabled = false
                }
              })
            } else {
              modifySceneService(sceneForm).then(response => {
                if (response.isSuccess) {
                  this.updateDataList()

                  this.$message.success('创建成功')
                  this.cancel()
                  this.disabled = false
                } else {
                  this.$message.error(response.errMsg)
                  this.disabled = false
                }
              })
            }
          } else {
            this.$message.error('表单验证失败，请正确填写相关内容后再重新提交')
            this.disabled = false
            return
          }
        })
      }
    },
    cancel() {
      this.editMode = 'create'
      this.sceneForm = {
        sceneName: '',
        displayMode: 'Sphere',
        coordinatesType: 'EPSG',
        coordinates: 'EPSG:3857',
        thumbnail: ''
      }
      this.crsInfo = {
        crsType: 'EPSG',
        crsString: ''
      }
      this.closeDialog()
    },
    deleteImage(e) {
      e.stopPropagation()
      this.sceneForm.thumbnail = ''
    },
    handleBeforeUpload(file) {
      if (file.size / 1024 / 1024 > 2) {
        this.$message.error('文件大小不能超过2M')
        return false
      }
      this.$set(this.uploadParams, 'FileSize', file.size)
      this.$set(this.uploadParams, 'FileName', file.name)
    },
    handleChange(file) {
      this.$set(this.uploadParams, 'FileName', file.name)
      let upload = this.$refs.upload
      if (file.size < CompressSize) {
        this.$set(this.uploadParams, 'FileSize', file.size)
        upload.submit()
      } else {
        this.getBase64(file.raw).then(response => {
          this.compressImgBySize(response, 2 * 1024).then(res => {
            let fileOfBlob = new File([res], file.name)
            this.$set(this.uploadParams, 'FileSize', fileOfBlob.size)
            this.$set(this.uploadParams, 'FileInfo', fileOfBlob)
            upload.submit()
          })
        })
      }
    },
    handleAvatarSuccess(response, file) {
      // 图片上传成功
      if (response.isSuccess) {
        let data = response.data
        this.sceneForm.thumbnail = data.savePath
      } else {
        this.$message.error(response.errMsg)
      }
    },
    handleAvatarError() {
      this.$message.error('图片上传失败')
    },
    getUploadUrl() {
      let uploadUrl = `${window.serverUrl}/${this.$logServeCof()}/project/scene/v3/thumbnail/upload`
      return uploadUrl
    },
    getTitle() {
      let title = ''
      if (Object.keys(this.sceneInfo).length) {
        title = '编辑基本信息'
      } else {
        title = '创建场景'
      }
      return title
    },
    getBase64,
    compressImgBySize,
    getToken,
    getTokenId
  }
}
</script>

<style lang="less" scoped>
@import '@/assets/css/publishSearch.less';
.tips-box {
  display: flex;
  line-height: 25px;
  font-size: 12px;
  margin-top: 24px;
  padding-left: 82px;
  .icon-box {
    // color: var(--success-status-color);
    .text {
      margin-left: 10px;
      // color: var(--default-color);
    }
  }

  .tips-content-box {
    color: var(--default-color);
  }
}

.common-form-box {
  color: var(--default-color);

  .radio-group-box {
    margin-top: 9px;
  }

  /deep/ .el-form {
    .el-form-item__label {
      line-height: 32px;
    }

    .el-form-item__content {
      line-height: 32px;
    }

    .el-form-item__error {
      margin-top: 4px;
    }
  }

  .crs-form-box {
    display: flex;
    margin-left: -120px;
    .label {
      width: 120px;
      text-align: right;

      &::before {
        content: '*';
        color: var(--error-status-color);
        margin-right: 5px;
      }
    }

    .crs-box {
      flex-grow: 1;
      margin-top: 8px;
    }
  }

  .thumbnail-uploader-box {
    display: flex;
    margin-top: 10px;

    .label {
      width: 97px;
      text-align: right;
    }

    /deep/ .el-upload {
      flex-grow: 1;
      padding: 8px;
      width: 210px;
      height: 160px;
      &:has(.not-avatar):hover {
        background: none;
      }
      .el-upload-dragger {
        border: none;
        background-color: transparent;
        padding: 0;
        height: 100%;

        .upload-tip {
          display: flex;
          align-items: center;
          flex-direction: column;
        }
      }
    }

    .avatar-box {
      position: relative;
      width: 100%;
      height: 100%;
      .avatar {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
      .icon {
        position: absolute;
        top: 6px;
        right: 6px;
        color: var(--default-color);
        background: var(--base-bg-dark-color5);
        padding: 5px;
        border-radius: 50%;
        font-size: 12px;
      }
    }

    .upload-tip {
      margin: auto;

      .icon {
        color: var(--upload-icon-color);
        font-size: 40px;
      }

      .tip-text {
        margin-top: 5px;
        color: var(--base-dark4-color);
        font-size: 16px;

        .avatar-uploader-icon {
          font-size: 32px;
          color: var(--upload-icon-color);
        }

        .text-btn {
          margin-right: 4px;
        }

        .text-drap {
          font-size: 14px;
        }
      }
    }
  }
}
</style>
